import * as React from "react";
import { SecondaryHeadingWrap } from "../SecondaryHeadingWrap";
import { SecondaryHeadingWrapAmerican } from "../SecondaryHeadingWrapAmerican";
import { SecondaryHeadingWrapMultiview } from "../SecondaryHeadingWrapMultiview";
export class SecondaryHeadingPicker extends React.PureComponent {
    getContentType() {
        const HeadingContentStyles = {
            American: SecondaryHeadingWrapAmerican,
            Regular: SecondaryHeadingWrap,
            Multiview: SecondaryHeadingWrapMultiview
        };
        return HeadingContentStyles[this.props.cardType];
    }
    render() {
        const shouldExpand = this.props.renderedHeadings < this.props.cms.ExpandedGroupItems;
        const eventsCount = this.props.cms.ShowLeaguesEventsCount
            ? `(${this.props.eventsCountLength})`
            : "";
        const props = Object.assign(Object.assign({}, this.props), { shouldExpand, eventsCount });
        const ContentType = this.getContentType();
        return React.createElement(ContentType, Object.assign({}, props), this.props.children);
    }
}
//# sourceMappingURL=SecondaryHeadingPicker.js.map